/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

const createSurfaceDisplay = (productForm) => {
    let quantityInput = null;

    const updateDisplay = () => {
        const display = productForm.querySelector('[data-surface-per-unit]');
        if (!display) return;

        const surface = parseFloat(display.dataset.surfacePerUnit) || 0;
        const qty = parseInt(quantityInput?.value, 10) || 1;
        const valueEl = display.querySelector('.surface-display__value');

        if (surface === 0) {
            display.hidden = true;
            return;
        }

        display.hidden = false;
        if (valueEl) valueEl.textContent = (surface * qty).toFixed(2);
    };

    const bindQuantityInput = () => {
        const input = productForm.querySelector('input[name="quantity"]');
        if (!input || input === quantityInput) return;

        quantityInput = input;

        quantityInput.addEventListener('change', updateDisplay);
        quantityInput.addEventListener('input', updateDisplay);

        productForm.addEventListener('click', (e) => {
            if (e.target.closest('[data-quantity]')) {
                setTimeout(updateDisplay, 50);
            }
        });

        updateDisplay();
    };

    new MutationObserver(bindQuantityInput).observe(productForm, {
        childList: true,
        subtree: true,
    });

    bindQuantityInput();
};

document.querySelectorAll('.js-product-form').forEach(createSurfaceDisplay);